// Version : 1.0.0
// Author : AGALYA
const DrivingLicenceActionType = {
	/** ***************** UPDATE DRIVING LICENCE  START *********************** */
	UPDATE_DRIVING_LICENCE_START: 'update_driving_licence_start',
	UPDATE_DRIVING_LICENCE_SUCCESS: 'update_driving_licence_success',
	UPDATE_DRIVING_LICENCE_FAILURE: 'update_driving_licence_failure',
	UPDATE_DRIVING_LICENCE_RESPONSE_REST_START: 'update_driving_licence_response_reset_start',
	UPDATE_DRIVING_LICENCE_RESPONSE_CHANGED: 'update_driving_licence_response_changed',
	/** ***************** UPDATE DRIVING LICENCE END *********************** */
};

export default DrivingLicenceActionType;
